function stringToCm(feet, inches) {
    const cm = feet * 30.48 + inches * 2.54;
    return cm;
}

function stringToInches(feet, inches) {
    const totalInches = feet * 12 + inches;
    return totalInches;
}

function lbsToKgs(weightInLbs) {
    const weightInKgs = weightInLbs * 0.45359237;
    return weightInKgs;
}

function calculateBMI(weight, feet, inches) {
    const heightInInches = stringToInches(feet, inches);
    const BMI = (weight / (heightInInches * heightInInches)) * 703;
    return Math.round(BMI);
}

function calculateBMR(weight, feet, inches, age, sex) {
    var calories;
    if (sex == "Male") {
        calories = 66.5 + (13.75 * lbsToKgs(weight) + (5.003 * stringToCm(feet, inches)) - (6.75 * age));
    } else {
        calories = 655.1 + (9.563 * lbsToKgs(weight) + (1.850 * stringToCm(feet, inches)) - (4.676 * age));
    }
    // Round to the nearest 5
    calories = Math.round(calories / 5) * 5;

    calories += 100;

    if (calories > 2300) {
        return 2300;
    } else if (calories < 1600) {
        return 1600;
    } return calories;
}

function calculateMacros(bmr, calories) {
    var proteinLowerRange = Math.round((bmr * 0.35 / 4) / 5) * 5;
    var proteinUpperRange = Math.round((bmr * 0.4 / 4) / 5) * 5;

    var carbsLowerRange = Math.round((bmr * 0.25 / 4) / 5) * 5;
    var carbsUpperRange = Math.round((bmr * 0.3 / 4) / 5) * 5;

    var fatsLowerRange = Math.round((bmr * 0.25 / 9) / 5) * 5;
    var fatsUpperRange = Math.round((bmr * 0.3 / 9) / 5) * 5;

    return {
        protein: {
            lower: `${proteinLowerRange}g`,
            upper: `${proteinUpperRange}g`,
        },
        carbs: {
            lower: `${carbsLowerRange}g`,
            upper: `${carbsUpperRange}g`,
        },
        fats: {
            lower: `${fatsLowerRange}g`,
            upper: `${fatsUpperRange}g`,
        }
    };
}

function getBMIRange(bmi) {
    if (bmi < 18.5) {
        return "underweight range";
    } else if (bmi >= 18.5 && bmi < 24.9) {
        return "healthy weight range";
    } else if (bmi >= 25 && bmi < 29.9) {
        return "overweight range";
    } else {
        return "obese range";
    }
}

function submitMetrics() {
    var fields = {
        "age": {"id": "CalculatorForm-age1","value": null, type: "number"},
        "height": {"id": "CalculatorForm-height2","value": null, type: "string"},
        "current_weight": {"id": "CalculatorForm-current-weight3","value": null, type: "number"},
        "weight": {"id": "CalculatorForm-goal-weight4","value": null, type: "number"},
        "sex": {"id": "CalculatorForm-sex5","value": null, type: "string"},
        "email": {"id": "CalculatorForm-email","value": null, type: "string"},
        "phone": {"id": "CalculatorForm-phone","value": null, type: "string"},
    }

    var missingFields = [];

    for (const field in fields) {
        var value = $(`#${fields[field].id}`).val();

        if (value == "" || value == null || value == undefined) {
            missingFields.push(field);
            console.log(`Missing field: ${field}`);
        } else {
            if (fields[field].type == "number") {
                value = parseFloat(value);
            }
            fields[field].value = value;
            console.log(`Field ${field} has value ${fields[field].value}`);
        }
    }

    if (missingFields.length > 0) {
        alert(`Please fill in the following fields: ${missingFields.join(", ")}`);
        return;
    }

    var current_weight = fields.current_weight.value
    var weight = fields.weight.value;
    var feetInchesArray = fields.height.value.split("'")
    var feet = parseInt(feetInchesArray[0].replace("'", ""),10);
    var inches = parseInt(feetInchesArray[1].replace("'", ""),10);
    var age = fields.age.value;
    var sex = fields.sex.value;

    var lowerCalorieThreshold = calculateBMR(
        weight,
        feet,
        inches,
        age,
        sex
    );
    var upperCalorieThreshold = lowerCalorieThreshold + 100;
    var calorieThreshold = `${lowerCalorieThreshold} - ${upperCalorieThreshold}`;

    const BMI = calculateBMI(current_weight, feet, inches);
    const bmiRange = getBMIRange(BMI);

    const MACROS = calculateMacros(lowerCalorieThreshold, BMI);
    const proteinThreshold = `${MACROS.protein.lower} - ${MACROS.protein.upper}`
    const carbsThreshold = `${MACROS.carbs.lower} - ${MACROS.carbs.upper}`
    const fatsThreshold = `${MACROS.fats.lower} - ${MACROS.fats.upper}`;

    // set these values in local storage calorieThreshold, proteinThreshold, carbsThreshold, fatsThreshold, BMI, bmiRange
    localStorage.setItem("calorieThreshold", calorieThreshold);
    localStorage.setItem("proteinThreshold", proteinThreshold);
    localStorage.setItem("carbsThreshold", carbsThreshold);
    localStorage.setItem("fatsThreshold", fatsThreshold);
    localStorage.setItem("BMI", BMI);
    localStorage.setItem("bmiRange", bmiRange);

    $('#CalculatorForm').submit();
}

function clearLocalStorage() {
    localStorage.removeItem("calorieThreshold");
    localStorage.removeItem("proteinThreshold");
    localStorage.removeItem("carbsThreshold");
    localStorage.removeItem("fatsThreshold");
    localStorage.removeItem("BMI");
    localStorage.removeItem("bmiRange");
}

function loadSubmittedMacros() {
    const calorieThreshold = localStorage.getItem("calorieThreshold");
    const proteinThreshold = localStorage.getItem("proteinThreshold");
    const carbsThreshold = localStorage.getItem("carbsThreshold");
    const fatsThreshold = localStorage.getItem("fatsThreshold");
    const BMI = localStorage.getItem("BMI");
    const bmiRange = localStorage.getItem("bmiRange");

    if (calorieThreshold && proteinThreshold && carbsThreshold && fatsThreshold && BMI && bmiRange) {
        $('#generated_macros').html(
            createHTML(calorieThreshold, proteinThreshold, carbsThreshold, fatsThreshold, BMI, bmiRange)
        );
    }
}

function createHTML(calorieThreshold, proteinThreshold, carbsThreshold, fatsThreshold, BMI, bmiRange) {
    return `
            <table class="table-fill">
                <tbody class="table-hover">
                    <tr>
                        <td class="text-left">Daily Calories</td>
                        <td class="text-left" id="calories">${calorieThreshold}</td>
                    </tr>
                    <tr>
                        <td class="text-left">Protein</td>
                        <td class="text-left" id="protein">${proteinThreshold}</td>
                    </tr>
                    <tr>
                        <td class="text-left">Carbohydrates</td>
                        <td class="text-left" id="carbohydrates">${carbsThreshold}</td>
                    </tr>
                    <tr>
                        <td class="text-left">Fats</td>
                        <td class="text-left" id="fats">${fatsThreshold}</td>
                    </tr>
                    <tr>
                        <td class="text-left">BMI</td>
                        <td class="text-left" id="bmi">${BMI}</td>
                    </tr>
                </tbody>
            </table>

            <p>
                Based on your body metrics & your <b>goal weight</b>, here are your personalized weight loss macronutrient and calorie goals!
            </p>

            <p>
                BMI or body mass index is a screening method for weight category. BMI can serve as a screening tool for weight status, but its inability to distinguish between muscle and fat mass may lead to misleading assessments of individual health.
            </p>

            <p>
                Based on your current weight and your BMI you are considered in the <b class="sqsrte-text-color--accent">${bmiRange}.</b>
            </p>

            <p>
                To take the next step towards your health goals, utilize these macronutrients alongside the Total Weight Loss Cookbook below!
            </p>

            <p>
                Please consult these calculations with your primary care physician if you have any medical conditions.
            </p>

            <style>
                table {
                    max-width: fit-content  !important;
                    border-radius: 5px;
                }
                .table-fill {
                    background: white;
                    border-radius: 3px;
                    border-collapse: collapse;
                    height: 320px;
                    margin: auto;
                    max-width: 600px;
                    padding: 5px;
                    width: 100%;
                }

                tr {
                    border-top: 1px solid #C1C3D1;
                    border-bottom: 1px solid #C1C3D1;
                    color: #666B85;
                    font-size: 16px;
                    font-weight: normal;
                }

                tr:first-child {
                    border-top: none;
                }

                tr:last-child {
                    border-bottom: none;
                }

                tr:nth-child(odd) td {
                    background: #d9dff7;
                }

                tr:last-child td:first-child {
                    border-bottom-left-radius: 3px;
                }

                tr:last-child td:last-child {
                    border-bottom-right-radius: 3px;
                }

                td {
                    background: #FFFFFF;
                    padding: 20px;
                    text-align: left;
                    vertical-align: middle;
                    font-weight: 300;
                    font-size: 18px;
                    border-right: 1px solid #C1C3D1;
                }

                tr td:first-child {
                    background-color:#01186c;
                    color:#fff;
                }


                td:last-child {
                    border-right: 0px;
                }

                th.text-left {
                    text-align: left;
                }

                th.text-center {
                    text-align: center;
                }

                th.text-right {
                    text-align: right;
                }

                td.text-left {
                    text-align: left;
                }

                td.text-center {
                    text-align: center;
                }

                td.text-right {
                    text-align: right;
                }

                p {
                    margin-top: 15px;
                    margin-bottom: 15px;
                }
            </style>
         `
}

